/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

// Core imports
import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

// Component imports
import { Col, Form, Input, Row, Typography } from 'antd';

// Misc imports
import { useBotLanguage } from '../../../../utils/hooks/useBotLanguage';

// Constant declarations
const { Paragraph, Text } = Typography;

const DynamicMultiOptionNodeForm = () => {
  const { t } = useTranslation();
  const { isEditingPrimaryLanguage } = useBotLanguage();

  return (
    <Fragment>
      <Row>
        <Col span={24}>
          <Text>
            {t('Template data key')}
          </Text>
        </Col>
        <Col span={24}>
          <Paragraph type="secondary">
            {t('Set by the client in the metadata, under the templateData section.')}
          </Paragraph>
        </Col>
      </Row>

      <Form.Item
        name={['data', 'dynamicDataKey']}
        normalize={value => {
          // Replace all spaces with dashes
          return value.split(' ').join('-');
        }}
        rules={[{ required: true, message: t('Data key cannot be blank.') }]}
        className="mb-0"
      >
        <Input
          prefix="templateData."
          placeholder={t('e.g. country')}
          size="large"
          disabled={!isEditingPrimaryLanguage}
        />
      </Form.Item>
    </Fragment>
  );
};

export default DynamicMultiOptionNodeForm;
